/**
 * Einheitliche API-Basis-URL für fetch, apiClient, SSE usw.
 *
 * REACT_APP_API_URL (Beispiele):
 * - https://mein-backend.up.railway.app/api  (deploytes Backend)
 * - http://localhost:5000/api                 (lokal, direkt)
 * - /api                                      (lokal über CRA-Dev-Server-Proxy → package.json "proxy")
 *
 * Ohne Schema (https://) ergänzen wir es automatisch, damit keine „relative“ URL unter /admin/... entsteht.
 */

/**
 * @param {string} raw
 * @returns {string}
 */
export function normalizeApiBaseUrl(raw) {
  let u = String(raw || '').trim();
  if (!u) {
    return 'http://localhost:5000/api';
  }
  if (u.startsWith('/')) {
    return u.replace(/\/+$/, '') || '/api';
  }
  if (!/^https?:\/\//i.test(u)) {
    if (/^(localhost|127\.0\.0\.1)(:|\/|$)/i.test(u)) {
      u = `http://${u}`;
    } else {
      u = `https://${u}`;
    }
  }
  return u.replace(/\/+$/, '');
}

/**
 * @returns {string}
 */
export function getApiBaseUrl() {
  const trimmed = process.env.REACT_APP_API_URL?.trim();
  const envSet = trimmed !== undefined && trimmed !== '';

  if (envSet) {
    return normalizeApiBaseUrl(trimmed);
  }

  // In Produktion keine dynamische Host-Erkennung (Reduziert Risiko bei manipuliertem Host-Header).
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }

  let base = 'http://localhost:5000/api';
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    if (hostname && hostname !== 'localhost' && hostname !== '127.0.0.1') {
      base = `${protocol}//${hostname}:5000/api`;
    }
  }
  return base;
}
